export default __webpack_public_path__ + "static/media/oe06.90970a97.jpg";